__turbopack_context__.v({
  "root": "ServiceIconsWithTooltip-module__v3repW__root",
});
